/**
 * @description method to handle slider change value
 * @returns formattedValue
 */
export const sliderChangeValue = (
	newValue: number | number[],
	minRange: string,
	maxRange: string,
) => {
	let formattedValue = '';

	if (typeof newValue === 'number') {
		formattedValue = newValue?.toString();
		formattedValue = displayMinMaxRange(
			newValue,
			minRange,
			maxRange,
			formattedValue,
		);
	} else if (Array.isArray(newValue) && newValue.length > 0) {
		formattedValue = newValue[0]?.toString();
		formattedValue = displayMinMaxRange(
			newValue[0],
			minRange,
			maxRange,
			formattedValue,
		);
	}

	return formattedValue;
};

/**
 * @description method to handle slider change value
 * @returns formattedValue
 */
export const displayMinMaxRange = (
	newValue: number | number[],
	minRange: string,
	maxRange: string,
	formattedValue: string,
) => {
	if (newValue === Number(minRange)) {
		formattedValue = minRange;
	} else if (newValue === Number(maxRange)) {
		formattedValue = maxRange;
	}
	return formattedValue;
};
